/** Service API pour le module Comptabilité (OHADA). */
import api from './api';
import type {
  CompteComptable, Journal, ExerciceComptable, EcritureComptable,
  Balance, GrandLivre, CompteResultat, Bilan, LigneEcriture,
} from '../types/comptabilite';

const BASE = '/comptabilite';

const list = <T,>(d: T[] | { results: T[] }): T[] => (Array.isArray(d) ? d : d.results);

interface PeriodeParams { exercice?: number; date_debut?: string; date_fin?: string }

export const comptabiliteApi = {
  getComptes: () =>
    api.get<CompteComptable[] | { results: CompteComptable[] }>(`${BASE}/comptes/`).then(r => list(r.data)),

  getJournaux: () =>
    api.get<Journal[] | { results: Journal[] }>(`${BASE}/journaux/`).then(r => list(r.data)),

  getExercices: () =>
    api.get<ExerciceComptable[] | { results: ExerciceComptable[] }>(`${BASE}/exercices/`).then(r => list(r.data)),

  getResultatExercice: (id: number) =>
    api.get<{ exercice: string; total_produits: number; total_charges: number; resultat_net: number; cloture: boolean }>(
      `${BASE}/exercices/${id}/resultat/`,
    ).then(r => r.data),

  cloturerExercice: (id: number) =>
    api.post<{ message: string; resultat_net: number; ecriture_cloture: string | null; exercice: ExerciceComptable }>(
      `${BASE}/exercices/${id}/cloturer/`, {},
    ).then(r => r.data),

  getEcritures: (params?: { journal?: number; exercice?: number; search?: string }) =>
    api.get<EcritureComptable[] | { results: EcritureComptable[] }>(`${BASE}/ecritures/`, { params })
      .then(r => list(r.data)),

  createEcriture: (data: {
    journal: number; date_ecriture: string; libelle: string; reference?: string;
    lignes: LigneEcriture[];
  }) => api.post<EcritureComptable>(`${BASE}/ecritures/`, data).then(r => r.data),

  // États
  getBalance: (params?: PeriodeParams) =>
    api.get<Balance>(`${BASE}/rapports/balance/`, { params }).then(r => r.data),

  getGrandLivre: (compte: string, params?: PeriodeParams) =>
    api.get<GrandLivre>(`${BASE}/rapports/grand_livre/`, { params: { compte, ...params } }).then(r => r.data),

  getJournalGeneral: (params?: { journal?: number; exercice?: number; date_debut?: string; date_fin?: string }) =>
    api.get<EcritureComptable[]>(`${BASE}/rapports/journal_general/`, { params }).then(r => r.data),

  getCompteResultat: (params?: PeriodeParams) =>
    api.get<CompteResultat>(`${BASE}/rapports/compte_resultat/`, { params }).then(r => r.data),

  getBilan: (params?: PeriodeParams) =>
    api.get<Bilan>(`${BASE}/rapports/bilan/`, { params }).then(r => r.data),

  // URL d'export Excel (à utiliser avec downloadFile)
  exportUrl: `${BASE}/rapports/export/`,
};
